import {TestOrder} from "./test-order.model";

export class TestOrderTestSelectionSession {
  SelectedPanelIds: Array<number>;
  SelectedPanels: Array<TestOrderPanel>;
  CategoryRollup: any;
  FavoritesByCategory: any;
  PanelsForCategory: Array<TestOrderPanel>;
  IndividualTestPanelsForCategory: Array<TestOrderPanel>;
  PanelsForAll: TestOrderPanel[];
  IndividualTestPanelsForAll: TestOrderPanel[];


  constructor(testOrder?: TestOrder) {
    testOrder = testOrder || new TestOrder();
    this.SelectedPanels = testOrder.SelectedPanels || [];
    this.SelectedPanelIds = testOrder.PanelGuids || [];
    this.CategoryRollup = {};
    this.FavoritesByCategory = {};
    this.PanelsForCategory = [];
    this.IndividualTestPanelsForCategory = [];
    this.PanelsForAll = [];
    this.IndividualTestPanelsForAll = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/test-order-test-selection-session.model.ts